import React from "react"
import styled from "styled-components"
import { Tab, Tabs, TabList, TabPanel } from "react-tabs"

import { Title, Wrapper } from "Styles"
import { theme } from "Theme"

// const Wrapper = styled.div`
//   color: ${props =>
//     props.dark ? theme.colors.black.base : theme.colors.white.base};
//   min-height: ${(props) => (props.big ? '400px;' : '100px;')};
//   background: none;
//   position: relative;
//   overflow: hidden;
//   display: flex;
//   flex-direction: column-reverse;

//   align-items: center;
//   margin: 0 auto;
//   @media (min-width: ${theme.breakpoints.s}) {
//   }
//   @media (min-width: ${theme.breakpoints.m}) {
//     flex-direction: row;
//     flex-direction: ${(props) => (props.layout == 'ltr' ? `row` : `row-reverse`)};
//     margin: 0 auto 0;
//   }
//   @media (min-width: ${theme.breakpoints.l}) {
//   }
//   .gatsby-image-wrapper {
//     position: initial !important;
//   }
// `;

const Content = styled.div`
  width: 100%;
  padding: 3rem 0;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const Grid = styled.div`
  padding: 2rem 0 0;
  margin: 0 auto;
  width: 100%;
  max-width: ${theme.layout.base};
`

const OptionsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    grid-template-columns: repeat(auto-fill, minmax(18%, 1fr));
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }

  grid-gap: 16px;
  .option-card {
    background: ${theme.colors.white.base};
    display: flex;
    height: 100%;
    flex-direction: column;
    padding: 1rem;
    border: 1px solid #ccc;
    border-radius: ${theme.borderRadius.ui};
    svg {
      color: ${theme.colors.black.base};
      width: 16px;
      height: 16px;
    }
  }
  .option-popular {
    @media (min-width: ${theme.breakpoints.s}) {
    }
    @media (min-width: ${theme.breakpoints.m}) {
      transform: scale(1.06);
      grid-template-columns: repeat(auto-fill, minmax(18%, 1fr));
    }
    @media (min-width: ${theme.breakpoints.l}) {
    }

    border: 1px solid ${theme.colors.primary.base};
    color: ${theme.colors.white.base};
    box-shadow: ${theme.shadow.feature.small.default};
    svg {
      color: ${theme.colors.primary.base};
      width: 16px;
      height: 16px;
    }
    .option-type {
      background: ${theme.colors.primary.base};
    }
  }
`

const OptionType = styled.div`
  background: #ddd;
  padding: 2px 8px;
  border-radius: ${theme.borderRadius.elements};
  display: inline-block;
  width: auto;
  font-size: ${theme.fontSize.smallish};
  font-weight: bold;

  // display: flex;
  // width: 100%;
  max-width: ${theme.layout.base};
  margin: 0 0 6px;
  img {
    height: 16px;
    width: auto;
    margin: 0 6px 0 0;
  }
`

const OptionPrice = styled.h4`
  color: ${theme.colors.black.base};
  font-size: ${theme.fontSize.smallish};

  font-weight: bold;
  width: 100%;
  max-width: ${theme.layout.base};
`

const OptionDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

const OptionList = styled.h5`
  color: ${theme.colors.black.base};
  font-size: ${theme.fontSize.smallish};
  font-weight: normal;
  width: 100%;
  max-width: ${theme.layout.base};
  margin: 0 0 1rem;
`

const OptionItem = styled.div`
  height: 100%;
  font-size: ${theme.fontSize.smallish};
`

const Options = ({
  big,
  dark,
  layout,

  data,
  region,
}) => (
  <Wrapper layout={layout} dark={dark ? 1 : undefined} big={big}>
    <Content>
      <Title>Pricing for {region}</Title>
      <hr />
      <Grid>
        <OptionsGrid>
          {data.map((option, i) => (
            <OptionItem key={i}>
              {option.listing == "single" ? (
                <div key={i} className={`option-card ${option.content.tabs[0].popular ? "option-popular" : ""}`}>
                  <div>
                    <OptionType className="option-type">{option.content.tabs[0].type}</OptionType>
                    <OptionPrice>{option.content.tabs[0].price}</OptionPrice>
                    <hr />
                  </div>
                  <OptionDetails>
                    <div>
                      {option.content.tabs[0].details.map((det, i) => (
                        <div key={i}>
                          <OptionList>
                            <svg viewBox="0 0 16 16">
                              <path
                                fill="inherit"
                                d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm-1.765-4.29a1 1 0 0 0 1.41.005l.664-.655L11.8 6.568a.765.765 0 0 0 0-1.081l-.288-.289a.765.765 0 0 0-1.08.001L6.948 8.682 5.581 7.314a.765.765 0 0 0-1.081 0l-.29.29a.765.765 0 0 0 0 1.08l1.36 1.36.665.666z"
                              />
                            </svg>{" "}
                            {det}
                          </OptionList>
                        </div>
                      ))}
                    </div>
                  </OptionDetails>
                </div>
              ) : (
                <div key={i} className={`option-card ${option.content.tabs[0].popular ? "option-popular" : ""}`}>
                  <div>
                    <OptionType className="option-type">{option.content.tabs[0].type}</OptionType>
                    <OptionPrice>{option.content.tabs[0].price}</OptionPrice>
                  </div>
                  <Tabs>
                    <TabList>
                      <Tab>Conference</Tab>
                      <Tab>Gala</Tab>
                    </TabList>

                    {option.content.tabs.map((eventTab, i) => (
                      <TabPanel key={i}>
                        <OptionDetails>
                          <div>
                            {eventTab.details.map((det, i) => (
                              <div key={i}>
                                <OptionList>
                                  <svg viewBox="0 0 16 16">
                                    <path
                                      fill="inherit"
                                      d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm-1.765-4.29a1 1 0 0 0 1.41.005l.664-.655L11.8 6.568a.765.765 0 0 0 0-1.081l-.288-.289a.765.765 0 0 0-1.08.001L6.948 8.682 5.581 7.314a.765.765 0 0 0-1.081 0l-.29.29a.765.765 0 0 0 0 1.08l1.36 1.36.665.666z"
                                    />
                                  </svg>{" "}
                                  {det}
                                </OptionList>
                              </div>
                            ))}
                          </div>
                        </OptionDetails>
                      </TabPanel>
                    ))}
                  </Tabs>
                </div>
              )}
            </OptionItem>
          ))}
        </OptionsGrid>
      </Grid>
    </Content>
  </Wrapper>
)

export default Options
